import { IconCreditCard, IconArrowUpRight } from "@tabler/icons-react";
import styles from "./ClientActivitySummary.module.css";
import Button from "../../components/UI/Button/button";
import moment from "moment";

export default function SubscriptionStatusCard({ subscription }) {
  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <div className={styles.cardHeaderLeft}>
          <div className={`${styles.cardIcon} ${styles.cardIconAmber}`}>
            <IconCreditCard size={18} />
          </div>
          <div>
            <div className={styles.cardTitle}>Subscription Status</div>
            <div className={styles.cardSubtitle}>Current plan details</div>
          </div>
        </div>
      </div>
      <div className={styles.cardBody}>
        <div className={styles.subRow}>
          <span className={styles.subLabel}>Plan</span>
          <span className={styles.subValue}>
            {subscription?.planName}
          </span>
        </div>
        <div className={styles.subRow}>
          <span className={styles.subLabel}>Quota remaining</span>
          <span className={`${styles.subValue} ${styles.subValueGood}`}>
            {subscription?.totalCredits} / {subscription?.totalCreditsGranted}
          </span>
        </div>
        <div className={styles.subRow}>
          <span className={styles.subLabel}>Expires</span>
          <span className={styles.subValue}>
            {moment(subscription?.validityPeriod).format("MMM DD, YYYY")}
          </span>
        </div>
        <Button
          as="a"
          href="/subscription-payment"
          variant="ghost"
          leftIcon={<IconArrowUpRight size={15} />}
          className={styles.subUpgradeBtn}
        >
          Upgrade Plan
        </Button>
      </div>
    </div>
  );
}
